import React, { useState, useEffect } from 'react'
import "./usermgmt.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Dropdown } from 'react-bootstrap';
import Papa from 'papaparse';

const Usermgmt = () => {
  const [modalShow1, setModalShow1] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [withorder, setwithorder] = useState(null);
  const [UserId, setUserId] = useState("")
  const [Name, setName] = useState("")
  const [Email, setEmail] = useState("")
  const [Address, setAddress] = useState([])
  const [searchvalue, setsearchvalue] = useState("")
  const [index, setindex] = useState(0)
  const [loginfilterData, setloginfilterData] = useState("0")
  const [user, setuser] = useState([])
  const [totalUsers, setTotalUsers] = useState(0)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);

  const getusers = async (page = 1, search = "", orderType = null, loginDays = "0") => {
    try {
      const queryParams = new URLSearchParams({
        page,
        limit: itemsPerPage,
        ...(search && { search }),
        ...(orderType && { orderType }),
        ...(loginDays !== "0" && { loginDays })
      }).toString();

      const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetUser?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      });

      const data = await response.json();

      if (data.status === 200) {
        setuser(data.data);
        setTotalUsers(data.pagination.total);
        setTotalPages(data.pagination.pages);
      } else {
        toast.error(data.message || "No User Found");
        setuser([]);
        setTotalUsers(0);
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error("Failed to fetch users");
    }
  }

  useEffect(() => {
    getusers(currentPage);
  }, [currentPage]);

  const handleExportCSV = async () => {
    try {
      const queryParams = new URLSearchParams({
        ...(searchvalue && { search: searchvalue }),
        ...(withorder && { orderType: withorder }),
        ...(loginfilterData !== "0" && { loginDays: loginfilterData })
      }).toString();

      const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminExportUsers?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const csvData = await response.text();
        const blob = new Blob([csvData], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'user_data.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("CSV exported successfully");
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Failed to export CSV");
      }
    } catch (error) {
      console.error('Export Error:', error);
      toast.error("Failed to export CSV");
    }
  };

  const search = () => {
    setCurrentPage(1);
    getusers(1, searchvalue, withorder, loginfilterData);
  }

  const sort = (value) => {
    setwithorder(value);
    setCurrentPage(1);
    getusers(1, searchvalue, value, loginfilterData);
  }

  const loginFilter = (value) => {
    setloginfilterData(value);
    setCurrentPage(1);
    getusers(1, searchvalue, withorder, value);
  }

  const updateStatus = async (id, status) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminUpdateUserStatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          UserId: id,
          Status: status
        })
      });

      const data = await response.json();
      if (data.status === 200) {
        toast.success(data.message);
        getusers(currentPage, searchvalue, withorder, loginfilterData);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Update Status Error:', error);
      toast.error("Failed to update user status");
    }
  }

  const deleteUser = async (id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminDeleteUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          UserId: id,
        })
      });

      const data = await response.json();
      if (data.status === 200) {
        toast.success(data.message);
        getusers(currentPage, searchvalue, withorder, loginfilterData);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Delete User Error:', error);
      toast.error("Failed to delete user");
    }
  }

  const getUserData = async (index) => {
    const selectedUser = user[index];
    setUserId(selectedUser.user.UserId);
    setName(`${selectedUser.user.FirstName || ""} ${selectedUser.user.LastName || ""}`);
    setEmail(selectedUser.user.Email);
    setAddress(selectedUser.user.Address);
    setModalShow3(true);
  }

  const deleteAddress = (index) => {
    const newAddress = [...Address];
    newAddress.splice(index, 1);
    setAddress(newAddress);
  }

  const updateUser = async () => {
    if (Name === "" || Email === "") {
      toast.error("Please fill all the fields");
      return;
    }
    else if (!Email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminUpdateUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          FirstName: Name.split(" ")[0],
          LastName: Name.split(" ")[1] ? Name.split(" ")[1] : "",
          UserId,
          Email: Email,
          Address: Address
        })
      });

      const data = await response.json();
      if (data.status === 200) {
        toast.success(data.message);
        setModalShow3(false);
        getusers(currentPage, searchvalue, withorder, loginfilterData);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Update User Error:', error);
      toast.error("Failed to update user");
    }
  }

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const getUserIndex = (id) => {
    const userIndex = user.findIndex((item) => item.user.UserId === id);
    setindex(userIndex);
  }

  const refreshData = () => {
    setsearchvalue("");
    setwithorder(null);
    setloginfilterData("0");
    setCurrentPage(1);
    getusers(1);
    toast.success("Data refreshed successfully");
  }

  function daysLeftToNextTwoYearsFromDate(startDate) {
    if (!startDate) return null;
    try {
      const startDateObj = new Date(startDate);
      const warrantyEndDate = new Date(startDateObj);
      warrantyEndDate.setFullYear(startDateObj.getFullYear() + 2);
      const daysDifference = Math.ceil((warrantyEndDate - new Date()) / (1000 * 60 * 60 * 24));
      return daysDifference;
    } catch (error) {
      console.error("Invalid date format:", startDate, error);
      return null;
    }
  }

  function daysLeftToNextThreeYearsFromDate(startDate) {
    if (!startDate) return null;
    try {
      const startDateObj = new Date(startDate);
      const warrantyEndDate = new Date(startDateObj);
      warrantyEndDate.setFullYear(startDateObj.getFullYear() + 3);
      const daysDifference = Math.ceil((warrantyEndDate - new Date()) / (1000 * 60 * 60 * 24));
      return daysDifference;
    } catch (error) {
      console.error("Invalid date format:", startDate, error);
      return null;
    }
  }

  return (
    <>
      <section className="dashbg-color">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">
              <div className="search-bar">
                <div className="search-container">
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    search();
                  }}>
                    <input
                      type="text"
                      placeholder="Search by- Name, Phone"
                      name="search"
                      value={searchvalue}
                      onChange={(e) => {
                        setsearchvalue(e.target.value);
                        if (e.target.value === '') {
                          getusers(); // Call getUser when input is cleared
                        }
                      }}
                    />
                    <button type="submit"><i className="fa fa-search"></i></button>
                  </form>
                </div>
              </div>

              <div className="filters">
                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle id="dropdown-autoclose-true" className="btn filter-pop">
                    Sort by <i className="fa fa-sort"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => sort("With")}>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="flexRadioDefault" checked={withorder === "With"} />
                        <label className="form-check-label">
                          With Order
                        </label>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => sort("Without")}>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="flexRadioDefault" checked={withorder === "Without"} />
                        <label className="form-check-label">
                          Without Order
                        </label>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => sort("Abandoned")}>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="flexRadioDefault" checked={withorder === "Abandoned"} />
                        <label className="form-check-label">
                          Abandoned Order
                        </label>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <button className="btn Export-btn filter-pop" onClick={handleExportCSV}>
                  Export CSV <i className='fas fa-file-export'></i>
                </button>

                {/* <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                   <i className="fas fa-sync-alt"></i>
                </button> */}

                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle id="dropdown-autoclose-true" className="btn filter-pop">
                    Filter by Last User Login <i className="fa fa-user"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => loginFilter("7")}>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="flexRadioDefault" checked={loginfilterData === "7"} />
                        <label className="form-check-label">
                          Filter by Last 7 days Login
                        </label>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => loginFilter("30")}>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="flexRadioDefault" checked={loginfilterData === "30"} />
                        <label className="form-check-label">
                          Filter by Last 30 days Login
                        </label>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => loginFilter("0")}>
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="flexRadioDefault" checked={loginfilterData === "0"} />
                        <label className="form-check-label">
                          All Data
                        </label>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                   <i className="fas fa-sync-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12 table-bg">
            <div style={{ backgroundColor: "white" }}>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Address</th>
                      <th scope="col">Orders</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Abandoned cart</th>
                      <th scope="col">Abandoned quantity</th>
                      <th scope='col'>User Login Time</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user.length > 0 ? user.map((item, idx) => {
                      const amount = item.order.reduce((total, orderItem) => {
                        const itemSum = orderItem.OrderDetail.reduce((a, b) => parseInt(a) + parseInt(b.OrderSubTotal), 0);
                        return total + itemSum;
                      }, 0);

                      const AbandonedQty = item.abdonedorder.reduce((sum, item) => sum + parseInt(item.OrderQuantity, 10), 0);

                      return (
                        <tr key={idx}>
                          <td scope="row">#{totalUsers - ((currentPage - 1) * itemsPerPage + idx)}</td>
                          <td>{item.user.Phone}</td>
                          <td>{item.user.FirstName} {item.user.LastName}</td>
                          <td>{item.user.Email}</td>
                          <td>
                            <div className="eyealign">
                              <span>
                                {item.user.Address.length > 0 ?
                                  `${item.user.Address[0].FirstName} ${item.user.Address[0].LastName} ${item.user.Address[0].Phone} ${item.user.Address[0].Address} ${item.user.Address[0].Address1}, ${item.user.Address[0].City}, ${item.user.Address[0].State}. ${item.user.Address[0].Pincode}`
                                  : ""}
                              </span>
                              {item.user.Address.length > 0 &&
                                <i className="fa fa-eye" onClick={() => {
                                  setModalShow1(true);
                                  getUserIndex(item.user.UserId);
                                }} />
                              }
                            </div>
                          </td>
                          <td>
                            <div className="eyealign">
                              <span>{item.order.length}</span>
                              <i className="fa fa-eye" onClick={() => {
                                setModalShow(true);
                                getUserIndex(item.user.UserId);
                              }} />
                            </div>
                          </td>
                          <td>Rs.{amount}</td>
                          <td>
                            <div className="eyealign">
                              <span>{item.abdonedorder.length}</span>
                              <i className="fa fa-eye" onClick={() => {
                                setModalShow2(true);
                                getUserIndex(item.user.UserId);
                              }} />
                            </div>
                          </td>
                          <td>
                            <div className="eyealign">
                              <span>{AbandonedQty}</span>
                            </div>
                          </td>
                          <td>{item.user.updatedAt}</td>
                          <td>
                            <div className="eyealign">
                              <span>
                                {item.user.Status === "Active" ?
                                  <i className="fa fa-ban text-danger" aria-hidden="true" onClick={() => {
                                    updateStatus(item.user.UserId, "Inactive");
                                  }}></i> :
                                  <i className="fa fa-check-circle text-success" aria-hidden="true" onClick={() => {
                                    updateStatus(item.user.UserId, "Active");
                                  }}></i>
                                }
                              </span>
                              <i className="fa fa-pencil text-warning" onClick={() => getUserData(idx)} />
                              <i className="fa fa-trash text-danger" onClick={() => deleteUser(item.user.UserId)} />
                            </div>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr>
                        <td colSpan="11" className="text-center">No User Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="row">
                  <div className="col-lg-12 text-center" style={{ position: "relative" }}>
                    <div className="pagination pagi">
                      <a href="javascript:void(0)"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                        style={{ pointerEvents: currentPage === 1 ? 'none' : 'auto', opacity: currentPage === 1 ? 0.5 : 1 }}
                      >
                        &laquo;
                      </a>

                      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                        let pageNum;
                        if (totalPages <= 5) {
                          pageNum = i + 1;
                        } else if (currentPage <= 3) {
                          pageNum = i + 1;
                        } else if (currentPage >= totalPages - 2) {
                          pageNum = totalPages - 4 + i;
                        } else {
                          pageNum = currentPage - 2 + i;
                        }
                        return (
                          <a
                            key={pageNum}
                            href="javascript:void(0)"
                            onClick={() => goToPage(pageNum)}
                            className={currentPage === pageNum ? "active" : ""}
                          >
                            {pageNum}
                          </a>
                        );
                      })}

                      <a href="javascript:void(0)"
                        onClick={nextPage}
                        disabled={currentPage === totalPages}
                        style={{ pointerEvents: currentPage === totalPages ? 'none' : 'auto', opacity: currentPage === totalPages ? 0.5 : 1 }}
                      >
                        &raquo;
                      </a>
                    </div>
                    <div className="table-no-count">
                      Showing {Math.min((currentPage - 1) * itemsPerPage + user.length, totalUsers)} of {totalUsers} results
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Address Modal */}
        <Modal show={modalShow1} size="md" centered>
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbar">
              <div className="col-lg-12 p-3 d-flex">
                <div className="col-8 align-content-center" style={{ paddingRight: "20px" }}>
                  <h3>Address</h3>
                </div>
                <div className="col-4">
                  <img src="assets/cross.svg" style={{ cursor: "pointer" }} alt="" onClick={() => setModalShow1(false)} />
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row inner-cntnt p-4">
              <form>
                {user.length > 0 && user[index]?.user.Address.length > 0 &&
                  user[index].user.Address.map((item, idx) => (
                    <div className="mb-3 col-12" key={idx} style={{ position: "relative" }}>
                      <label className="form-label">Address {idx + 1}</label>
                      <textarea
                        type="text"
                        className="form-control"
                        value={`${item.Address} ${item.Address1}, ${item.City}, ${item.State}. ${item.Pincode}`}
                        style={{ height: "100px" }}
                        readOnly
                      />
                      <span style={{
                        color: "lightgray",
                        fontSize: "10px",
                        position: "absolute",
                        right: "-4rem",
                        top: "7rem"
                      }}>
                        ({item.AddressType})
                      </span>
                    </div>
                  ))
                }
              </form>
            </div>
          </Modal.Body>
        </Modal>

        {/* Update User Modal */}
        <Modal show={modalShow3} size="md" centered>
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbar">
              <div className="col-lg-12 p-3 d-flex">
                <div className="col-9 align-content-center" style={{ paddingRight: "20px" }}>
                  <h3>Update Detail</h3>
                </div>
                <div className="col-3">
                  <img src="assets/cross.svg" style={{ cursor: "pointer" }} alt="" onClick={() => setModalShow3(false)} />
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row inner-cntnt p-4">
              <form>
                <div className='mb-3 col-12'>
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className='mb-3 col-12'>
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {Address.map((item, idx) => {
                  const value = `${item.Address} ${item.Address1}, ${item.City}, ${item.State}. ${item.Pincode}`;
                  return (
                    <div className="mb-3 col-12" key={idx} style={{ position: "relative" }}>
                      <label className="form-label">Address {idx + 1}</label>
                      <textarea
                        type="text"
                        className="form-control"
                        value={value}
                        style={{ height: "100px" }}
                        readOnly
                      />
                      <span style={{
                        color: "lightgray",
                        fontSize: "10px",
                        position: "absolute",
                        right: "-2rem",
                        top: "7rem",
                        cursor: "pointer"
                      }}>
                        <i className='fa fa-trash text-danger' onClick={() => deleteAddress(idx)}></i>
                      </span>
                    </div>
                  );
                })}
                <div className="mb-3 col-12" style={{ display: "flex", justifyContent: "end" }}>
                  <button type="button" className="btn buttonUpdate" onClick={updateUser}>
                    Update
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        {/* Orders Modal */}
        <Modal show={modalShow} size="xl" centered>
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbox p-1">
              <div className="col-lg-12 p-2 d-flex justify-content-between">
                <div className="col-sm-7" style={{ paddingRight: "3rem", paddingTop: "0.3rem" }}>
                  <h3>Orders</h3>
                </div>
                <div className="col-sm-5">
                  <img className="img-fluid" src="assets/cross.svg" style={{ cursor: "pointer" }} alt="" onClick={() => setModalShow(false)} />
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row mt-1 p-4">
              {/* Regular Products (Fans) */}
              {user.length > 0 && user[index].order.some(item =>
                item.OrderDetail.some(mainitem =>
                  !mainitem.OrderName?.toLowerCase().includes('led bulb') &&
                  !mainitem.OrderName?.toLowerCase().includes('geyser')
                )
              ) && (
                  <div className="col-lg-12 table-bg">
                    <h5 className="p-1 text-center">Fans</h5>
                    <div className="table-responsive p-1">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Order Id</th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Colour</th>
                            <th scope="col">Sweep Sizes</th>
                            <th scope="col">Price</th>
                            <th scope="col">Warranty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user[index].order.map((item, orderIndex) => (
                            item.OrderDetail.filter(mainitem =>
                              !mainitem.OrderName?.toLowerCase().includes('led bulb') &&
                              !mainitem.OrderName?.toLowerCase().includes('geyser')
                            ).map((mainitem, i) => (
                              <tr key={`${orderIndex}-${i}`}>
                                <td>{item.OrderId}</td>
                                <td>{mainitem.OrderName}</td>
                                <td>{mainitem.OrderQuantity}</td>
                                <td>{mainitem.OrderColor}</td>
                                <td>{mainitem.OrderSize}</td>
                                <td>Rs.{mainitem.OrderSubTotal}</td>
                                <td>
                                  {mainitem.OrderExtendedWarranty ?
                                    mainitem.OrderName.toLowerCase().includes("exhaust fan") ?
                                      daysLeftToNextThreeYearsFromDate(item.createdAt) > 0 ?
                                        `${daysLeftToNextThreeYearsFromDate(item.createdAt)} days` :
                                        "Expired" :
                                      daysLeftToNextTwoYearsFromDate(item.createdAt) > 0 ?
                                        `${daysLeftToNextTwoYearsFromDate(item.createdAt)} days` :
                                        "Expired" :
                                    ""}
                                </td>
                              </tr>
                            ))
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              {/* LED Bulbs */}
              {user.length > 0 && user[index].order.some(item =>
                item.OrderDetail.some(mainitem =>
                  mainitem.OrderName?.toLowerCase().includes('led bulb')
                )
              ) && (
                  <div className="col-lg-12 table-bg mt-1">
                    <h5 className="p-1 text-center">LED Bulbs</h5>
                    <div className="table-responsive p-1">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Order Id</th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Pack Of</th>
                            <th scope="col">Power Consumption</th>
                            <th scope="col">Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user[index].order.map((item, orderIndex) => (
                            item.OrderDetail.filter(mainitem =>
                              mainitem.OrderName?.toLowerCase().includes('led bulb')
                            ).map((mainitem, i) => (
                              <tr key={`${orderIndex}-${i}`}>
                                <td>{item.OrderId}</td>
                                <td>{mainitem.OrderName}</td>
                                <td>{mainitem.OrderQuantity}</td>
                                <td>{mainitem.OrderColor}</td>
                                <td>{mainitem.OrderSize}</td>
                                <td>Rs.{mainitem.OrderSubTotal}</td>
                              </tr>
                            ))
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              {/* Geysers */}
              {user.length > 0 && user[index].order.some(item =>
                item.OrderDetail.some(mainitem =>
                  mainitem.OrderName?.toLowerCase().includes('geyser')
                )
              ) && (
                  <div className="col-lg-12 table-bg mt-1">
                    <h5 className="p-1 text-center">Geysers</h5>
                    <div className="table-responsive p-1">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Order Id</th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Colour</th>
                            <th scope="col">Capacity</th>
                            <th scope="col">Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user[index].order.map((item, orderIndex) => (
                            item.OrderDetail.filter(mainitem =>
                              mainitem.OrderName?.toLowerCase().includes('geyser')
                            ).map((mainitem, i) => (
                              <tr key={`${orderIndex}-${i}`}>
                                <td>{item.OrderId}</td>
                                <td>{mainitem.OrderName}</td>
                                <td>{mainitem.OrderQuantity}</td>
                                <td>{mainitem.OrderColor}</td>
                                <td>{mainitem.OrderSize}</td>
                                <td>Rs.{mainitem.OrderSubTotal}</td>
                              </tr>
                            ))
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
            </div>
          </Modal.Body>
        </Modal>

        {/* Abandoned Orders Modal */}
        <Modal show={modalShow2} size="xl" centered>
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbox p-1">
              <div className="col-lg-12 p-2 d-flex justify-content-between">
                <div className="col-sm-7" style={{ paddingRight: "3rem", paddingTop: "0.3rem" }}>
                  <h3>Abandoned Orders</h3>
                </div>
                <div className="col-sm-5">
                  <img className="img-fluid" src="assets/cross.svg" style={{ cursor: "pointer" }} alt="" onClick={() => setModalShow2(false)} />
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row mt-4 p-4">
              <div className="col-lg-12 table-bg">
                <div className="table-responsive p-3">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Colour</th>
                        <th scope="col">Sweep</th>
                        <th scope="col">Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.length > 0 && user[index].abdonedorder.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.OrderItemId}</td>
                          <td>{item.OrderName}</td>
                          <td>{item.OrderQuantity}</td>
                          <td>{item.OrderColor}</td>
                          <td>{item.OrderSize}</td>
                          <td>Rs.{item.OrderTotal}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  )
}

export default Usermgmt;